/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/maintenance.scss';

import React, {useEffect, useState} from 'react';
import {setMaintenanceLoggedIn} from "../../util/maintenanceUtil";
import {ErrorType, getSetting, navigate} from '@dvrd/dvr-controls';
import {BolmateButton, BolmatePasswordInput} from "../controls";
import Image from "../misc/image";
import {ORDERS_ROUTE} from "../../util/constants";

export default function Maintenance() {
    const [password, setPassword] = useState('');
    const [inputVisible, setInputVisible] = useState(false);
    const [error, setError] = useState<ErrorType>(null);

    function onDoubleClick(evt: React.MouseEvent) {
        evt.preventDefault();
        setInputVisible(true);
    }

    function onSubmit() {
        // It's no problem to put the password in the code as it is simply a maintenance page.
        if (password === 'YWo_3Je6jfJ*RCkGnCcJ*YkT') {
            setMaintenanceLoggedIn(true);
            navigate('/facturen');
        } else setError('Ongeldig wachtwoord');
    }

    function onChange(value: string) {
        setPassword(value);
        setError(null);
    }

    function onClickWeb() {
        window.location.href = 'https://bolmate.nl';
    }

    useEffect(() => {
        if (!getSetting('maintenanceMode')) navigate(ORDERS_ROUTE);
    }, []);

    return (
        <div className='maintenance'>
            <Image name='logo' className='logo' onDoubleClick={onDoubleClick}/>
            {/*<img src={getImg('logo')} alt='Bolmate.nl' className='logo' onDoubleClick={onDoubleClick}/>*/}
            <h1>Onderhoud</h1>
            <p className='message'>Bolmate wordt momenteel bijgewerkt naar de nieuwste versie, u kunt daarom tijdelijk
                geen gebruik maken van Bolmate. We doen ons best om de update zo spoedig mogelijk uit te voeren. Excuses
                voor het ongemak.</p>
            <BolmateButton onClick={onClickWeb} label='Terug naar de website'/>
            {inputVisible && <BolmatePasswordInput onChange={onChange} value={password} label='Wachtwoord'
                                                   inputProps={{placeholder: 'Wachtwoord'}} onEnter={onSubmit}
                                                   className='pass-field' error={error} autoFocus onFocus={() => {
                setError(null)
            }}/>}
        </div>
    )
}